module.exports = {
  title: 'Sphere Waves with Skia',
  author: 'Enzo Manuel Mangano',
  date: '2025-12-09',
  slug: 'sphere-waves',
  tags: ['skia', 'reanimated', 'gesture-handler'],
};
